module.exports = __webpack_public_path__ + "media/images/icons/flags/PA-975d73d9a2d7e4f4da3f4f835888bb90.svg";